package com.essntl.uikit.components.iconbutton.outline

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.button.outline.getOutlineButtonColors
import com.essntl.uikit.components.button.primary.getPrimaryButtonColors
import com.essntl.uikit.components.iconbutton.EsIconButton
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsMediumOutlineIconButton(
    onClick: () -> Unit,
    iconRes: String,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsIconButton(
        onClick = onClick,
        size = EsButtonSize.Medium,
        colors = getOutlineButtonColors(essntlColorScheme),
        iconRes = iconRes,
        enabled = enabled,
        loading = loading,
        border = BorderStroke(
            width = 1.dp,
            color = essntlColorScheme.borderPrimary,
        ),
        interactionSource = interactionSource,
        modifier = modifier,
    )
}